import React, { useState, useEffect } from 'react';
import { 
  getNotificationPermission, 
  requestNotificationPermission,
  isPushNotificationSupported 
} from '../services/pushNotifications';
import { getMobileType } from '../utils/deviceDetection';
import '../styles/notificationPrompt.css';

const NotificationPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [permission, setPermission] = useState(getNotificationPermission());

  useEffect(() => {
    // Check if we should show the prompt
    const checkPromptEligibility = () => {
      // Don't show on desktop/PC devices
      const deviceType = getMobileType();
      if (deviceType === 'desktop') return;
      
      if (!isPushNotificationSupported()) return;
      
      const currentPermission = getNotificationPermission();
      setPermission(currentPermission);
      
      // Only show if permission is 'default' (not asked yet)
      if (currentPermission === 'default') {
        // Check if user has engaged with videos
        const hasWatchedVideo = localStorage.getItem('has_watched_video');
        const promptDismissed = localStorage.getItem('notification_prompt_dismissed');
        const promptDismissedTime = localStorage.getItem('notification_prompt_dismissed_time');
        
        // Don't show if recently dismissed (within 7 days)
        if (promptDismissed && promptDismissedTime) {
          const dismissedDate = new Date(parseInt(promptDismissedTime));
          const daysSinceDismissed = (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
          if (daysSinceDismissed < 7) return;
        }
        
        // Show prompt if user has watched a video
        if (hasWatchedVideo && !promptDismissed) {
          setTimeout(() => setShowPrompt(true), 3000); // Show after 3 seconds
        }
      }
    };

    checkPromptEligibility();
  }, []);

  const handleAllow = async () => {
    const result = await requestNotificationPermission();
    if (result) {
      setPermission('granted');
    }
    // Persist dismissal so the prompt never shows again after user acts on it
    localStorage.setItem('notification_prompt_dismissed', 'true');
    localStorage.setItem('notification_prompt_dismissed_time', Date.now().toString());
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('notification_prompt_dismissed', 'true');
    localStorage.setItem('notification_prompt_dismissed_time', Date.now().toString());
    setShowPrompt(false);
  };

  if (!showPrompt || permission !== 'default') return null;

  return (
    <div className="notification-prompt-overlay">
      <div className="notification-prompt">
        <div className="notification-prompt-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            <circle cx="12" cy="8" r="3" fill="red" opacity="0.8" />
          </svg>
        </div>
        <h3>Get Live Stream Notifications</h3>
        <p>Be the first to know when we go live! Get instant notifications for new streams.</p>
        <div className="notification-prompt-buttons">
          <button className="notification-prompt-allow" onClick={handleAllow}>
            Enable Notifications
          </button>
          <button className="notification-prompt-later" onClick={handleDismiss}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPrompt;